import React, { useState, useCallback } from 'react';
import { createPortal } from 'react-dom';
import styles from './use-error-dialog.module.css';

const ErrorDialogComponent = ({ error, onClose }) => {
    if (!error) return null;

    return createPortal(
        <div className={styles.errorDialogOverlay} onClick={onClose}>
            <div className={styles.errorDialog} onClick={e => e.stopPropagation()}>
                <div className={styles.errorDialogHeader}>
                    <h3 className={styles.errorDialogTitle}>Error</h3>
                </div>
                <div className={styles.errorDialogContent}>
                    <p className={styles.errorDialogMessage}>{error}</p>
                </div>
                <div className={styles.errorDialogFooter}>
                    <button className={styles.errorDialogButton} onClick={onClose}>
                        OK
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export const useErrorDialog = () => {
    const [error, setError] = useState(null);

    const showError = useCallback((message) => {
        setError(message);
    }, []);

    const clearError = useCallback(() => {
        setError(null);
    }, []);

    const ErrorDialog = useCallback(() => (
        <ErrorDialogComponent
            error={error}
            onClose={clearError}
        />
    ), [error, clearError]);

    return {
        error,
        showError,
        clearError,
        ErrorDialog
    };
};